import axios from "axios";
import { downloadFile } from "@/api/file";
export function publicdownloadFile(fileurl, token, data, number, filename) {
  downloadFile({ list: data, number: number }).then(res => {
    const downloadurl = fileurl + res.msg + "?token=" + token;
    axios({
      method: "get",
      url: downloadurl,
      responseType: "blob"
    }).then(data => {
      if (!data) {
        return;
      }
      const url = window.URL.createObjectURL(data.data);
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    });
  });
}
